export const getInitials = (fullName = '') => {
  if (fullName === null || !fullName.trim()) {
    return fullName
  }

  const names = (fullName ?? '')
    .toLocaleUpperCase()
    .split(' ')
    .filter(name => name.trim())

  if (names.length > 1) {
    return names.splice(0, 2).reduce((acc, each) => acc + each[0], '')
  }
  return names[0].slice(0, 2)
}
